import { configureStore } from "@reduxjs/toolkit";

import { fantasyReducer, rankingReducer, userReducer } from "./redux";

const store = configureStore({
	reducer: {
		user: userReducer,
		ranking: rankingReducer,
		fantasy: fantasyReducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({ thunk: {}, serializableCheck: false }),
});

export default store;
